import EthiopiaOld from "../Media/EthiopiaOld.jpg";
import ThailandOld from "../Media/ThailandOld.jpg";
import GuatemalaOld from "../Media/GuatemalaOld.jpg";
import NicaraguaOld from "../Media/NicaraguaOld.jpg";
import Colombia from "../Media/ColombiaProject.png";
import Nepal from "../Media/NepalProject.jpg";
import InlandEmpire from "../Media/InlandEmpireProjectPic.jpeg"

export const OldProjectsList = [
    {
        id: "nicaragua",
        name: "Nicaragua",
        image: NicaraguaOld,
        description: "Implement a new school house in the San Sebastián community in Nicaragua.",
    },
    {
        id: "ethiopiaold",
        name: "Ethiopia",
        image: EthiopiaOld,
        description: "Support for better education",
    },
    {
        id: "thailand",
        name: "Thailand",
        image: ThailandOld,
        description: "Schoolhouse building",
    },
    {
        id: "guatemala",
        name: "Guatemala",
        image: GuatemalaOld,
        description: "Rain harvest and water distribution",
    },
    {
    id: "colombia",
    name: "Colombia",
    image: Colombia,
    meetingTimes: "Tuesdays 6-7pm",
    description:
      "Combat food insecurity in Colombia by building three greenhouses",
  },
  {
    id: "nepal",
    name: "Nepal",
    image: Nepal,
    meetingTimes: "Thursdays 6-7pm",
    description:
      "Provide income and food sustainability to the Nepal Freedom School",
  },
  {
    id: "inland-empire",
    name: "Inland Empire",
    image: InlandEmpire,
    meetingTimes: "Wednesdays 6-7pm",
    description: "Enhance farming accessibility at Huerta del Valle through ADA garden beds"
  },
]
